module.exports = __webpack_public_path__ + "iPhone7-MatteBlack.png?bf7afcbc550a3937d32fd68c434d955d";